import AppUpdateSettings from "../components/AppUpdateSettings";
export default function SettingsApp() {
  return (
    <section className="space-y-5">
      <div>
        <h2 className="text-xl font-semibold">App</h2>
        <p className="text-sm text-gray-500 mt-1">
          Updates for this browser. Your profile and personal map preferences
          are in the account menu.
        </p>
      </div>
      <AppUpdateSettings />
      <p className="text-sm text-gray-500">
        Available updates appear here. Updating reloads the app, so finish any
        open forms first.
      </p>
    </section>
  );
}
